import { useThemeProvider } from "@providers/ThemeProvider/useThemeProvider";

import AffireLogoLightModeSVG from "./svg/affire-red-black.svg";
import AffireLogoDarkModeSVG from "./svg/affire-red-white.svg";

import classes from "./AffireLogo.module.css";

type Props = {
  height?: number;
};

export const AffireLogo = ({ height = 36 }: Props) => {
  const { isDarkMode } = useThemeProvider();

  return (
    <img
      className={classes.affireLogo}
      src={isDarkMode ? AffireLogoDarkModeSVG : AffireLogoLightModeSVG}
      style={{ height: `${height}px` }}
    />
  );
};
